<template>
  <div class="goods_left" v-if="menuChildren.length !== 0">
    <div class="cate">
      <div class="name">{{menuName}}</div>
      <div class="list">
        <ul>
          <li :class="{'selected' : childId === child.id}" @click="jumpgo('/designlist', child.id)" v-for="(child, i) in menuChildren">{{child.alias}}</li>

        </ul>
      </div>
    </div>
    <div class="advace">
      <el-button @click="jumpgo('/search')">Advance Search</el-button>
    </div>
  </div>
</template>

<script>
import {getDesignMenuChildren, getDesignMenuName} from '/api/index.js'
export default {
  name: 'DesignGoodsLeft',
  props: {
    // 标题内容
    topName: {
      type: String,
      default: 'Men'
    }
  },
  data () {
    return {
      menuChildren: [],
      id: null,
      menuName: '',
      childMenuName: '',
      childId: null
    }
  },
  created () {
    const parentId = this.$route.query.parentId
    const id = this.$route.query.id
    this.id = parentId
    this.childId = id
  },
  mounted () {
    this._getMenuChildren()
    this._getMenuName()
    const id = this.$route.query.id
    this.childId = id
  },
  watch: {
    $route () {
      const parentId = this.$route.query.parentId
      const id = this.$route.query.id
      this.id = parentId
      this.childId = id
      this._getMenuChildren()
      this._getMenuName()
    }
  },
  methods: {
    _getMenuName () {
      if (this.id !== null) {
        let params = {
          id: this.id
        }
        getDesignMenuName(params).then(res => {
          if (res.data != null) {
            this.menuName = res.data.alias
            this.$emit('getMenuName', this.menuName)
          }
        })
      }
      if (this.childId !== null) {
        let params1 = {
          id: this.childId
        }
        getDesignMenuName(params1).then(res => {
          if (res.data != null) {
            this.childMenuName = res.data.alias
            this.$emit('getChildMenuName', this.childMenuName)
          }
        })
      }
    },
    _getMenuChildren () {
      let params = {
        id: this.id
      }
      getDesignMenuChildren(params).then(res => {
        this.menuChildren = res.data
      })
    },
    jumpgo (url, type) {
      this.$router.push({
        path: url,
        query: {
          parentId: this.id,
          id: type
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.selected {
  background-color: #0E6EB8;
  color: white;
}
.goods_left {

  .cate {
    background: #fff;
    border-radius: 8px;

    .name {
      font-size: 18px;
      font-family: Poppins;
      font-weight: 400;
      color: #FFFFFF;
      padding: 15px 10px;
      padding-right: 0;
      line-height: 1;
      background: #036EB8;
      text-transform: uppercase;
      border-radius: 8px 8px 0 0;
    }

    .list {
      padding: 0 12px;

      ul {
        margin: 0;
        padding-left: 20px;
      }

      li {
        padding: 10px 0;
        border-top: 1px solid #e0e0e1;
        font-size: 15px;
        font-family: Poppins;
        font-weight: 400;
        color: #1A2127;
        text-decoration: none;

        &::marker {
          color: #662870;
        }

        &:hover {
          color: #662870;
          text-decoration: underline;
          cursor: pointer;
        }

        &:first-child {
          border: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// design_goods_left.vue?bd948a62